import { render } from "./item.vue?vue&type=template&id=6c7cdaa0&scoped=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"

import "./item.vue?vue&type=style&index=0&id=6c7cdaa0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c7cdaa0"

export default script